import { createSlice } from "@reduxjs/toolkit";
import { getNavigationDropdownList, getNavigations } from "./navigationThunk";

const initialState = {
  loading: false,
  navigationList: [],
  navigationDropdownList: [],
  pagination: {},
  error: null,
};

const navigationSlice = createSlice({
  name: "navigations",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getNavigations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getNavigations.fulfilled, (state, action) => {
        state.loading = false;
        state.navigationList = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(getNavigations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getNavigationDropdownList.fulfilled, (state, action) => {
        state.navigationDropdownList = action.payload;
      });
  },
});

export default navigationSlice.reducer;
